import { render, staticRenderFns } from "./experience.vue?vue&type=template&id=9c87b98a&scoped=true&"
import script from "./experience.vue?vue&type=script&lang=ts&"
export * from "./experience.vue?vue&type=script&lang=ts&"
import style0 from "./experience.vue?vue&type=style&index=0&id=9c87b98a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c87b98a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VTextField})
